<script>
    import NotificationModal from "./NotificationModal.svelte";
    import { apiMethods } from "../../Services/index.svelte";
    import { showError, showInfo } from "../../Utils/utilFunctions.svelte";
    import {
        showCommunicationConfirmationModal,
        communicationConfirmationModalDetails,
    } from "../../stores";

    export let encounterDetails = null;
    export let onProceed = null;

    let isProceeding = false;
    let isEnablingCommunications = false;

    $: patientEncounter =
        encounterDetails?.patientEncounter ?? encounterDetails ?? null;

    const resetDetails = () => {
        communicationConfirmationModalDetails.set({
            encounterDetails: null,
            onProceed: null,
        });
    };

    const closeModal = () => {
        isProceeding = false;
        isEnablingCommunications = false;
        showCommunicationConfirmationModal.set(false);
        resetDetails();
    };

    const handleProceed = async () => {
        if (isProceeding) return;
        isProceeding = true;
        try {
            if (typeof onProceed === "function") {
                await onProceed();
            }
            closeModal();
        } catch (error) {
            showError(error);
        } finally {
            isProceeding = false;
        }
    };

    const enableCommunicationsAndProceed = async () => {
        if (isEnablingCommunications || !patientEncounter?.id) return;
        isEnablingCommunications = true;

        try {
            await apiMethods.putMethod.updateDisableCommunication(
                patientEncounter.id,
                patientEncounter.disableNotifications ? 0 : 1
            );

            if (typeof patientEncounter.disableNotifications !== "undefined") {
                patientEncounter.disableNotifications = false;
            }

            showInfo("Patient Communication Enabled");

            if (typeof onProceed === "function") {
                await onProceed();
            }

            closeModal();
        } catch (error) {
            showError(error);
        } finally {
            isEnablingCommunications = false;
        }
    };
</script>

<NotificationModal
    isModalOpen={$showCommunicationConfirmationModal}
    title="Patient Communications"
    cancelText="Cancel"
    submitText="Proceed"
    closeModal={closeModal}
    closeModalFunction={closeModal}
    confirmAction={handleProceed}
    isConfirming={isProceeding}
    showCancelBtn={true}
    modalMaxWidth="max-w-2xl"
    contentClass="p-6 flex flex-col gap-y-2"
    btnOptions={[
        {
            text: "Enable communications and proceed",
            loading: isEnablingCommunications,
            function: enableCommunicationsAndProceed,
            class: "btn-primary",
            isDisabled: !patientEncounter?.id,
        },
    ]}
>
    <p>Patient communications are disabled. Patient will not be reached.</p>
    <p>Are you sure you want to proceed?</p>
</NotificationModal>
